import React from "react";
import BaseLayout from "../layout/BaseLayout";
import MainLayout from "../layout/MainLayout";
import privateRoutes from "./privateRoutes";
import publicRoutes from "./publicRoutes";
import NotFound from "../components/NotFound.jsx";

const routes = [
  {
    path: "/",
    element: <BaseLayout />,
    children: [...publicRoutes],
  },
  {
    path: "/",
    element: <MainLayout />,
    children: [...privateRoutes],
  },
  {
    path: "*",
    element: <NotFound />,
  },
];
export default routes;
